"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var ButtonWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Button/ButtonWidget");
var styles = __importStar(require("./Button.css"));
var sharedButtonStyles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Button/ButtonWidget.css"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var colord_1 = require("colord");
var getForegroundStyleVars = function (style) {
    var _a;
    var styleVars = __assign(__assign({}, (0, dynamic_1.assignInlineVars)((_a = {},
        _a[styles.publicButtonVars.boxShadowColor] = (0, colord_1.colord)(style.color.abs).alpha(0.5).toRgbString(),
        _a))), (0, ButtonWidget_1.makeButtonForegroundColor)(style));
    return styleVars;
};
var Button = function (_a) {
    var attributes = _a.attributes, text = _a.text, index = _a.index, href = _a.href, style = _a.style;
    return (react_1.default.createElement(ButtonWidget_1.ButtonWidgetContainer, { className: (0, classnames_1.default)(attributes.className, styles.container), style: __assign(__assign({}, attributes.style), getForegroundStyleVars(style)) },
        react_1.default.createElement(ButtonWidget_1.ButtonWidget, { className: (0, classnames_1.default)("button-widget__render", styles.buttonWidgetRender), size: style.size },
            react_1.default.createElement("a", __assign({ "data-qwilr-component-idx": index, "data-qwilr-component": "button-component" }, ((0, URL_1.isURL)(href, true) ? { href: href, target: "_blank", rel: "noopener" } : { href: "#" })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)("button-widget__button center", sharedButtonStyles.buttonWidgetButton) },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)("button-widget__button-text user-font", sharedButtonStyles.buttonWidgetButtonText) }, text))))));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(Button, { componentName: "Button" });
